// Multicurrency helper for quickview cart - runs on quickview open and formats price

function multiCurrencyCleanUpQuickview () {
  //console.log ('Multicurrency run');
  
  var activeCurrency = Shopify.currency["active"];

  if (activeCurrency == 'AUD') {var useCurrency = '$'} 
  else if (activeCurrency == 'CAD') {var useCurrency = '$'}
  else if (activeCurrency == 'DKK') {var useCurrency = 'kr.'}
  else if (activeCurrency == 'EUR') {var useCurrency = '€'}
  else if (activeCurrency == 'GBP') {var useCurrency = '£'}
  else if (activeCurrency == 'HKD') {var useCurrency = '$'}
  else if (activeCurrency == 'JPY') {var useCurrency = '¥'}
  else if (activeCurrency == 'NZD') {var useCurrency = '$'}
  else if (activeCurrency == 'SGD') {var useCurrency = '$'}
  else if (activeCurrency == 'USD') {var useCurrency = '$'}
  else if (activeCurrency == 'GBP') {var useCurrency = '£'};

  //console.log (useCurrency);
 
    $('.quickview_money').each(function() {      
      var html = $(this).html();
      var html = html / 100;
      var html = html.toFixed(2);
      var html = useCurrency + html;
      
      console.log (html);
      $(this).html(html);  
    });
  
};


(function($){

  var quickViewArr = [];

  $(document).ready(function(){
    $('.quickview-data').each(function(){
      quickViewArr.push($(this).attr('id'))
    });
  });

  function initGallery(){
    /* SLICK SLIDER SWITH BASED ON VARIANTS */
    $('.product-single__thumbnails .product-single__photos--thumbnail').each(function(index){
      var thisID = $(this).data('id');
      slickIndex.push(thisID);
    });

    $('.slider-for').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      asNavFor: '.slider-nav',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: true
          }
        }
      ]
    });

    $('.slider-nav').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      focusOnSelect: true,
      autoplay: false,
      adaptiveHeight: true
    });

    var slideObj    = $('.slider-for').slick('getSlick');
    var slideLength = slideObj.$slides.length;

    if( slideLength <= 1 ){
      $('.product-single__thumbnails').addClass('visually-hidden');
      $('.product-single__photos-wrapper').addClass('no-thumbs');
    } else {
      $('.product-single__thumbnails').removeClass('visually-hidden');
      $('.product-single__photos-wrapper').removeClass('no-thumbs');
    }
  }

  function loadQuickview(jsonID){
    var template = document.getElementById('template').innerHTML
    , compiled_template = Handlebars.compile(template)
    , quickview = JSON.parse(document.getElementById(jsonID).innerHTML)
    , inventoryAmount = quickview.inventory_quantity == null ? quickview.variants[0].inventory_quantity : quickview.inventory_quantity;

    // If logical operator helper
    //  }}
    Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {
      switch (operator) {
        case '==':
          return (v1 == v2) ? options.fn(this) : options.inverse(this);
        case '===':
          return (v1 === v2) ? options.fn(this) : options.inverse(this);
        case '!=':
          return (v1 != v2) ? options.fn(this) : options.inverse(this);
        case '!==':
          return (v1 !== v2) ? options.fn(this) : options.inverse(this);
        case '<':
          return (v1 < v2) ? options.fn(this) : options.inverse(this);
        case '<=':
          return (v1 <= v2) ? options.fn(this) : options.inverse(this);
        case '>':
          return (v1 > v2) ? options.fn(this) : options.inverse(this);
        case '>=':
          return (v1 >= v2) ? options.fn(this) : options.inverse(this);
        case '&&':
          return (v1 && v2) ? options.fn(this) : options.inverse(this);
        case '||':
          return (v1 || v2) ? options.fn(this) : options.inverse(this);
        default:
          return options.inverse(this);
      }
    });
    
    // If in logical operator helper
    //  
    Handlebars.registerHelper('ifIn', function (elem, list, options) {
      if (list.indexOf(elem) !== -1) {
        return options.fn(this);
      }
      return options.inverse(this);
    });

    // Define a new array for the first variant
    var variantOpt1 = [],
        prevOpt1 = '',
        showOpt1 = false;

    // Store the first variant distinct values in the new array
    for (var vrnt in quickview.variants) {
      if (quickview.variants[vrnt].option1 !== prevOpt1) {
        variantOpt1.push(quickview.variants[vrnt].option1);
      }
      prevOpt1 = quickview.variants[vrnt].option1;
    }

    // Use showOpt1 to show the variant only if there's more than 1 option
    if (variantOpt1.length > 1) {
      showOpt1 = true;
    }

    // Define a new array for the second variant
    var variantOpt2 = [],
        prevOpt2 = '',
        showOpt2 = false;

    // Store the second variant distinct values in the new array
    for (var vrnt in quickview.variants) {
      if (quickview.variants[vrnt].option2 !== prevOpt2) {
        variantOpt2.push(quickview.variants[vrnt].option2);
      }
      prevOpt2 = quickview.variants[vrnt].option2;
    }

    // Use showOpt2 to show the variant only if there's more than 1 option
    if (variantOpt2.length > 1) {
      showOpt2 = true;
    }

    // Define a new array for the third variant
    var variantOpt3 = [],
        prevOpt3 = '',
        showOpt3 = false;

    // Store the third variant distinct values in the new array
    for (var vrnt in quickview.variants) {
      if (quickview.variants[vrnt].option3 !== prevOpt3) {
        variantOpt3.push(quickview.variants[vrnt].option3);
      }
      prevOpt3 = quickview.variants[vrnt].option3;
    }

    // Use showOpt3 to show the variant only if there's more than 1 option
    if (variantOpt3.length > 1) {
      showOpt3 = true;
    }

    var rendered = compiled_template({
        title : quickview.title,
        url : quickview.url,
        handle : quickview.handle,
        id : quickview.id,
        vendor : quickview.vendor,
        type : quickview.type,
        price : quickview.price,
        variantTitle : quickview.options,
        firstVariant : quickview.options[0],
        description : quickview.description,
        images : quickview.images,
        variant : quickview.variants,
        showOption1 : showOpt1,
        variantOption1 : variantOpt1,
        showOption2 : showOpt2,
        variantOption2 : variantOpt2,
        showOption3 : showOpt3,
        variantOption3 : variantOpt3,
        inventory : inventoryAmount
    });


    
    document.getElementById('quickview-modal__content').innerHTML = rendered;


  multiCurrencyCleanUpQuickview();


    // Store first available variant ID
    var firstId = '';

    for (var i = 0; i < quickview.variants.length; i++) {
      if (quickview.variants[i].available == true) {
        firstId = quickview.variants[i].id;
        break;
      } else {
        continue;
      }
    }

    // go through select options and add selected to first available
    $('.quickview__select option, .no-js option').each(function() {
      if ($(this).val() == firstId) {
        $(this).attr('selected', 'selected');
      }
    });

    // disable button if no stock
    if (quickview.available == false) {
      $('.product-form__cart-submit').prop('disabled', true);
      $('.product-form__cart-submit span').text(theme.strings.soldOut);
    }

    $('.grid--uniform').addClass('quickview__active');

    if( $('.quickview__select').val() == "Default Title" ){
      $('.quickview-modal__content').addClass('single-variant');
    } else {
      $('.quickview__select option').each(function(){
        if( $(this).val() == '' ){
          $(this).parent('select').remove();
        }
      });
    }

    showContentModal();

    if( quickview.type.indexOf('Packages') > -1 ){
      var quickProdURL = '/products/'+quickview.handle;
      $('.product-form--quickview .product-form__cart-submit').on('click', function(e){
        e.preventDefault();
        window.location.href = quickProdURL;
      });
    }
  }

  function openModal(){
    $('.modal').addClass('modal--is-active');
    $('html').addClass('scroll-lock');

  }

  function closeModal(){
    $('.quickview-modal .product-template__container').removeClass('product-template__container--show');
    $('html').removeClass('scroll-lock');
    $('.modal').removeClass('modal--is-active');
  }

  function showContentModal(){
    setTimeout(function(){
      $('.quickview-modal__loader').hide();
    }, 320);

    setTimeout(function(){
      $('.quickview-modal .product-template__container').addClass('product-template__container--show');
      try {
        initGallery();
      } catch (e) {
        return true;
      }

      var iWish_added_format = document.getElementsByClassName('product-single__wishlist')[0].innerHTML.replace(/dd/g, 'dded');

      SPR.initDomEls();
      SPR.loadBadges();

      var sections = new theme.Sections();
      sections.register('collection-quickview', theme.Product);
    }, 800);
  }

  $('a[href="#quickview"]').on('click', function(e){
    e.preventDefault();

    var $this = $(this);
    var quickViewCurrentIndex = parseInt($this.attr('data-quickview-index'));
    var productJSON = quickViewArr[quickViewCurrentIndex];

    loadQuickview(productJSON);
    openModal();

    $.event.trigger({
      type: "convertCurrency"
    });

    $(document).on('click', '.modal--is-active', function(e){
      var targetName = e.target.className;

      if( targetName.indexOf('quickview-overlay') > -1 || targetName.indexOf('modal__close') > -1 || targetName.indexOf('icon-close') > -1 ){
        closeModal();
      }
    });
  });

  $('.collection-hero-control').on('click', function(e){
    $('.collection-hero').toggleClass('collection-hero--expanded');
  });

  $('.filter-group').each(function( index ) {
    $(this).find('h4').after($(this).find('.filter-clear'));
    $(this).find('.filter-dropdown').attr('data-index', $(this).find('.filter-column:last').attr('data-index'));
  });

  $('.filter-menu ul').each(function( index ) {
    if($(this).find('li.selected').length > 0) {
      var selected = $.map( $(this).find('li.selected'), function(element){ return $(element).text() }).join(", ")
      ,      count = $(this).find('li.selected').length;

      $(this).prev('.menu-trigger').find('.menu-trigger__count').show().html(count);
    }
  });

  function menutotop (item) {  
    console.log ('mobile filter menu opened');
    $('html, body').animate({scrollTop: item.offset().top -47 }, 'slow')
  };

  $('.menu-trigger').click(function(e) {
    //console.log ('menu clicked');
    $('.menu-trigger').not(this).next('ul').slideUp('fast');
    $(this).next('ul').slideToggle('fast');
      if ( ($(window).width() < 768) )  {
        setTimeout(menutotop, 200, $(this));
      };   
  });

/*  $(document).on('click', 'a[href="/apps/iwish"]', function(e) {
    if(typeof(Storage) !== "undefined") {
      e.preventDefault();
      iWishPost('/apps/iwish',{iwishlist:JSON.stringify(iWishlistmain),cId:iwish_cid});
    }
  });

  $(document).on('click', '.iWishAdd', function(e) {
    e.preventDefault();
    var iWishvId = $(this).parents('form').find("[name='id']").val();
    var iWish_added_format = document.getElementsByClassName('product-single__wishlist')[0].innerHTML.replace(/dd/g, 'dded');
    iwish_add($(this), iWishvId);
    return false;
  });
*/
  function mobileFilter(winWidth){
    if( winWidth <= 767 ){
      $('.filter-menu').css('height', $('body').height());
      //$('.filter-menu ul').first().show();
    } else {
      $('.filter-menu').css('height', 'auto');
      $('.filter-menu ul').first().hide();
    }
  }

  $(window).on("load resize", function(){
    mobileFilter($(window).width());
  });

  $('.filter-toggle').on('click', function(e){
    $('.filter-menu').toggleClass('filter-menu--show');
    // Change text for filter between filter and close   
    $('.filter-open-text').toggleClass("hide show");
    
    
  });
})(jQuery);


// NH - Filter bar advice
if ($(".filters-advice")[0]){
  if ($('.menu-trigger__title:contains("Size")').length > 0) {
    setTimeout(function(){
      var filtercookie = Cookies.get('filter-bar');

      if (filtercookie == 'opened') {
        console.log ('dont open filter advice')  
      }
      else {
        console.log ('open filter advice');
        $('.scroll-content').addClass('filters-highlight').stop().delay(7000).queue(function(){
          $(this).removeClass('filters-highlight');
      });

        $('.filters-advice').animate({height:"50px"}).delay(7000).animate({height:"0px"})
        $('.filters-advice-text').delay(300).fadeIn(300).delay(6400).fadeOut(300);

        console.log ('set cookie to not reopen filter bar')  
        Cookies.set('filter-bar', 'opened', { expires: 1 });

      }
    }, 2000);
  };
};


// NH - When filter dropped then scroll filters to top if screen height less than 760, width greater than 770

$('.menu-trigger').click(function(){
  //console.log ('filter opened');
  if ( ($(window).height() < 650) && ($(window).width() > 770) )  {
    if ($(this).closest('.filters-toolbar-sticky.stuck').length > 0) {
      console.log ('filters docked dont scroll');
    } else {
      console.log ('filters not docked do scroll');
      //console.log ('screen fits size criteria adjust position');
      $('html, body').animate({scrollTop: $('#filters-toolbar').offset().top -36 }, 'slow');
    }
  }
});